import { config } from 'sierra-client/config/global-config'

export const useOrganizationCanSendEmails = (): boolean => {
  return config.organization.canSendEmails ?? true
}
